import React from "react";
import { ReactComponent as Logo } from "assets/images/house_scan_logo.svg";
import { ReactComponent as EditIcon } from "assets/icons/edit_icon.svg";
import { ReactComponent as BookmarkIcon } from "assets/icons/bookmark.svg";
import { ReactComponent as QuestionIcon } from "assets/icons/question.svg";
import { ReactComponent as RemoveIcon } from "assets/icons/remove.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { useNavigate } from "react-router";
import { usePropertyActions } from "hooks/usePropertyActions";
import useProperties from "hooks/useProperties";
import useAuth from "hooks/useAuth";
import useSubscription from "hooks/useSubscription";
import PropertyNoteDialog from "components/Dialog/PropertyNoteDialog";
import ChooseAndCreateOrganiseList from "components/Dialog/ChooseAndCreateOrganiseList";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";
import useBookmark from "hooks/useBookmark";

const PropertyDetailsPageHeader = () => {
  const navigation = useNavigate();
  const { propertyDetails } = useProperties();
  const { user } = useAuth();
  const { subscriptionStatus } = useSubscription();
  const {
    isBookmarked,
    isDoubtProperty,
    isDiscardedProperty,
    handleAction,
    handleUpdateNote,
    isBookmarkPropertyHasNote,
    chooseOrganiseList,
    setChooseOrganiseList,
    handleAddBookmark,
    removeWarningPopupOpen,
    setRemoveWarningPopupOpen,
    handleRemoveConfirm,
  } = usePropertyActions(propertyDetails);
  const { togglePropertyNoteDialog, loading } = useBookmark();

  return (
    <header className="border-b sticky top-0 bg-white z-[11] border-[#EAECF0] h-20 p-5 flex items-center justify-between custom-shadow">
      <div className="relative">
        <Logo
          onClick={() => navigation("/")}
          className="w-[140px] cursor-pointer h-[31px] md:w-[185px] md:h-[40px]"
        />

        {/* Trial Crown Badge */}
        {user &&
          subscriptionStatus?.isInTrial &&
          subscriptionStatus?.trialDaysRemaining > 0 && (
            <div className="absolute -top-[12px] -right-[12px] md:-right-[25px] border-dashed border-[1px] border-primary rounded-full w-[30px] h-[30px] flex items-center justify-center">
              <span className="text-[8px] md:text-[12px] font-bold">
                {subscriptionStatus.trialDaysRemaining}g
              </span>
            </div>
          )}
      </div>

      <div className="flex items-center space-x-3">
        <EditIcon
          onClick={() => togglePropertyNoteDialog(propertyDetails?._id)}
          className="cursor-pointer w-[24px] h-[24px]"
        />
        <BookmarkIcon
          onClick={() => handleAction("bookmark")}
          className={`${
            isBookmarked
              ? "text-[#7BCD11]"
              : "hover:text-[#7BCD1133] text-white"
          } cursor-pointer  stroke-black w-7 h-7 transition-all stroke-[1.5px] duration-300 ease-in-out`}
        />
        <QuestionIcon
          onClick={() => handleAction("doubt")}
          className={`${
            isDoubtProperty
              ? "fill-[#FC9D47]"
              : "fill-white hover:fill-[#FEEDDA]"
          } cursor-pointer  transition-all w-7 h-7 stroke-[1.5px] duration-300 ease-in-out`}
        />
        <RemoveIcon
          onClick={() => handleAction("discard")}
          className={`${
            isDiscardedProperty ? "fill-[#FF6D59]" : "fill-white"
          }  cursor-pointer hover:fill-[#FFE2DE] stroke-[1.5px] w-[25px] h-[25px]  transition-all duration-300 ease-in-out`}
        />
        <CloseIcon
          onClick={() => {
            sessionStorage.setItem("returningFromDetails", "true");
            navigation(-1);
          }}
          className="cursor-pointer w-[20px] h-[20px] stroke-1"
        />
      </div>
      <RemoveWarningDialog
        warningText={removeWarningPopupOpen}
        isOpen={removeWarningPopupOpen}
        isClose={() => setRemoveWarningPopupOpen(null)}
        onClick={handleRemoveConfirm}
        buttonText2="Annulla"
      />
      <PropertyNoteDialog
        id={propertyDetails?._id}
        onClick={handleUpdateNote}
        loading={loading}
        defaultText={isBookmarkPropertyHasNote || ""}
      />
      <ChooseAndCreateOrganiseList
        isOpen={chooseOrganiseList}
        onClose={() => setChooseOrganiseList(false)}
        onSaveClick={handleAddBookmark}
      />
    </header>
  );
};

export default PropertyDetailsPageHeader;
